import { render } from "./SopForm.vue?vue&type=template&id=3735ff74&scoped=true"
import script from "./SopForm.vue?vue&type=script&lang=js"
export * from "./SopForm.vue?vue&type=script&lang=js"

import "./SopForm.vue?vue&type=style&index=0&id=3735ff74&lang=css"
import "./SopForm.vue?vue&type=style&index=1&id=3735ff74&scoped=true&lang=css"

import exportComponent from "/home/pewholesaleinnovelapp/wholesale.fresherproduce.ca/releases/81914199/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3735ff74"]])

export default __exports__